<template>
  <div>
    <el-dialog
      title="系统公告"
      width="700px"
      :close-on-click-modal="false"
      custom-class="system-dialog"
      :before-close="handleClose"
      :visible.sync="visible"
    >
      <div class="notice-box">
        <div class="title">【必看】国庆假期营销短信发送审核通知</div>
        <div>尊敬的商家朋友，您好！</div>
        <div>【京东官方通知】十一假期临近，辛苦各位商家超过20W的任务需要审核请提前创建。</div>
        <div>十一期间如无其他变动<span style="color: #FE4D45;font-weight: 600;">10月3日、10月6日 早9:00 </span>加审</div>
        <div>其他时间催审可能无法及时审核，请见谅，谢谢！</div>
        <div style="color: #000;font-weight: 600;">
          由于此次变更给您带来的不便我们深表歉意，感谢您的理解、支持和配合，如有问题可随时联系客服沟通处理，谢谢！
        </div>
        <div class="btn-wrap"><el-button type="primary" @click="handleClose">我已知晓</el-button></div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "notice",
  data() {
    return {
      visible: true,
    };
  },
  mounted() {},
  methods: {
    handleClose() {
      // this.visible = false;
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.notice-box {
  line-height: 18px;
  padding: 0 20px 25px 20px;
  font-size: 14px;
  .title {
    font-size: 18px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 25px;
    color: #333;
  }
  div {
    margin-bottom: 15px;
    color: #777;
  }
  .btn-wrap {
    text-align: center;
    margin-top: 40px;
  }
}
</style>
